<template>
  <h1 class="title has-text-centered is-spaced">
    <go-to-dashboard-button />

    {{ lockerDeliveriesQty }}
    {{ $tc("lockerDelivery.deliveries", lockerDeliveriesQty) }}
    <span v-show="!c1 && !c2">&nbsp;</span>

    <br v-show="c1" />

    <button class="button" @click="$emit('get-locker-deliveries')">
      <b-icon icon="sync-alt"></b-icon>
    </button>

    <div v-if="permissions.downloadLockerDeliveriesReport" class="inline">
      &nbsp;
      <button
        class="button"
        @click="$emit('download-locker-deliveries-report')"
        :style="c1 ? 'margin-top: 1rem;' : ''"
      >
        <b-icon icon="save"></b-icon>
      </button>
    </div>

    <!-- &nbsp;

    <b-field
      style="display: inline-block"
      :style="c1 ? 'margin-top: 1rem;' : 'margin-top: 10px;'"
    >
      <b-select
        :placeholder="$t('lockerDelivery.locker')"
        class="inline"
        v-model="locker"
        @input="$emit('update-locker', locker)"
      >
        <option value="">{{ $t("lockerDelivery.allLockers") }}</option>
        <option
          v-for="s in lockers"
          :key="s._id"
          :value="`${s._id}|${s.lockerInfo.name}`"
        >
          {{ s.lockerInfo.name }}
        </option>
      </b-select>
    </b-field> -->

    <hr />
  </h1>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common";
import { responsive } from "../../mixins/responsive";
import goToDashboardButton from "../common/GoToDashboardButton";

export default {
  props: ["lockerDeliveriesQty", "lockerId", "lockerName"],

  mixins: [common, responsive],

  components: {
    goToDashboardButton
  },

  data() {
    return {
      locker: undefined
    };
  },

  computed: {
    ...mapGetters(["lockers", "permissions"]),

    c1() {
      return this.windowWidth < 700;
    },

    c2() {
      return this.windowWidth < 370;
    }
  },

  mounted() {
    this.locker = `${this.lockerId}|${this.lockerName}`;
  }
};
</script>

<style scoped>
.inline {
  display: inline;
}
hr {
  background-color: hsl(0, 0%, 71%);
}
</style>
